import * as React from 'react';
import { Link } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import { MyToursPageDto } from '../../../../../api/MyTours';
import { PreferredTourFormat, TourStatuses, TourType } from '../../../../../utilities/Enums';
import { browserHistory } from '../../../../../utilities/history';
import { TourPage, tourSignupPath } from '../../signup/TourRouter';

interface Props {
    tourInfo: MyToursPageDto;
    openCancelPopup: () => void;
    openReschedulePopup: () => void;
    openStartTourPopup: () => void;
}

const MyToursPageButtons = ({
    tourInfo,
    openCancelPopup,
    openReschedulePopup,
    openStartTourPopup
}: Props) => {
    const rescheduleLogo = require('../../../../../images/reschedule-tour.png');
    const isComplete =
        (tourInfo.tour &&
            ((tourInfo.tour.tourStatus === TourStatuses.Complete && !tourInfo.blockedStatus) ||
                tourInfo.tour.tourStatus === TourStatuses.Finished)) ||
        (tourInfo.tour && tourInfo.tour.tourStatus === TourStatuses.Complete && !tourInfo.blockedStatus) ||
        tourInfo.virtualTourCompleted;

    const showStartTourButton =
        (tourInfo.preferredTourFormat === PreferredTourFormat.Virtual &&
            !tourInfo.virtualTourCompleted) ||
        (tourInfo.tour &&
            ((tourInfo.tour.tourStatus === TourStatuses.Scheduled && !tourInfo.blockedStatus) ||
                tourInfo.tour.tourStatus === TourStatuses.Reminded));

    return (
        <Col xs={12} lg={6} className="tour-buttons-col">
            {tourInfo.tour !== undefined &&
                tourInfo.tour !== null &&
                ((tourInfo.tour.tourStatus === TourStatuses.Scheduled && !tourInfo.blockedStatus)||
                    tourInfo.tour.tourStatus === TourStatuses.Reminded) &&
                (!tourInfo.tour.hasTourStarted || tourInfo.tour.tourType === TourType.Appless) && (
                    <div>
                        <button className="tour-cancel-button" onClick={() => openCancelPopup()}>
                            <label>Cancel</label>
                        </button>
                        <button
                            className="tour-reschedule-button"
                            onClick={() => openReschedulePopup()}
                        >
                            <img src={rescheduleLogo} className="tour-reschedule-or-cancel" />
                            <label>Reschedule</label>
                        </button>
                    </div>
                )}
            {(isComplete ||
                (tourInfo.tour && tourInfo.tour.tourStatus === TourStatuses.NoShow && !tourInfo.blockedStatus)) && (
                <button
                    className="tour-download-app-or-tour-again tour-again-or-reschedule"
                    onClick={() =>
                        browserHistory.push(
                            tourSignupPath(tourInfo.propertySlug)(TourPage.GuestCard)
                        )
                    }
                >
                    {isComplete ? 'Tour Again?' : 'Reschedule Tour'}
                </button>
            )}
            {isComplete && tourInfo.propertyLeasingUrl !== undefined && (
                <button
                    className="tour-download-app-or-tour-again apply-now"
                    onClick={() => (window.location.href = tourInfo.propertyLeasingUrl!)}
                >
                    Apply Now To Lease
                </button>
            )}
            {showStartTourButton && (
                <button className="tour-download-app-or-tour-again" onClick={openStartTourPopup}>
                    Start Tour
                </button>
            )}
            {tourInfo.tour && tourInfo.tour.tourStatus === TourStatuses.Cancelled && !tourInfo.blockedStatus && (
                <Link
                    className="complete-signup"
                    to={tourSignupPath(
                        tourInfo.propertySlug,
                        tourInfo.guestCardGuid
                    )(TourPage.GuestCard)}
                >
                    Reschedule Tour
                </Link>
            )}
            {!tourInfo.tour && tourInfo.preferredTourFormat !== PreferredTourFormat.Virtual && (
                <Link
                    className="complete-signup"
                    to={tourSignupPath(
                        tourInfo.propertySlug,
                        tourInfo.guestCardGuid
                    )(TourPage.GuestCard)}
                >
                    Complete Signup
                </Link>
            )}
        </Col>
    );
};

export default MyToursPageButtons;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/allTours/MyToursPageButtons.tsx